// ©2024 Austin App House. All rights reserved.
/* eslint-disable import/no-cycle */
import '../../sass/custom_styles/dashboard-modals.css';
import '../../sass/custom_styles/dashboard-responsive.css';
import React from 'react';
import ViewDetailsWorkOrderModal from './workOrderDetails';
import AdminFilters from './AdminFilters';
import ApplyModal from './ApplyModal';
import ImportWorkOrderModal from './ImportWorkOrderModal';
import ViewAllApplicantsForWorkOrder from './ViewAplicantsModal';
import UnAssignModal from './UnAssignModal';
import ContractorDetailsModal from './contractorDetailsModal';
import NearByContractorModal from './NearByContractorModal';
import CopyWorkOrderModal from './CopyWorkOrderModal';
import CancelWorkOrderExplanationModal from './CancelWorkOrderExplanationModal';
import Profile from './profile';
import GoogleMapsModal from './GoogleMapsModal';
import ImageViewModal from './ImageViewModal';
import BlockModal from './BlockModal';
import WorkOrderMessageSystemModal from './workOrderMessageSystemModal';
import MessageRateModal from './MessageRateModal';
import PortalContainer from './Portal';
import ContractorInviteSelectWorkOrder from './ContractorInviteSelectWorkOrder';
import AddFunds from './AddFunds';
import ErrorModal from './errorModal';
import BulkEditWorkOrders from './BulkEditWorkOrders';
import BulkMessageModal from './bulkMessageModal';
import CustomLoader from './CustomLoader';
import BulkWorkOrderApproveModal from './bulkWorkOrderApproveModal';
import BulkWorkOrderRouteContractorModal from './BulkWorkOrderRouteContractorModal';
import BulkWorkOrderAssignContractorModal from './BulkWorkOrderAssignContractorModal';
import ProjectAndCompanyControlModal from './projectAndCompanyControlModal';
import EditCustomFieldModal from './EditCustomFieldModal';
import EditClientApprovalCodeModal from './EditClientApprovalCodeModal';
import AddOrEditPaymentMethod from './AddOrEditPaymentMethod';
import AcceptAgreements from './AcceptAgreements';
import AddBankInfoForContractor from './AddBankInfoForContractor';
import SetUpBankInfoForContractor from './SetUpBankInfoForContractor';
import FiltersModal from './filters';
import ContractorTaxInformationModal from './ContractorTaxInformationModal';
import BulkWorkOrderPay from './BulkWorkOrderPay';
import ConfirmModal from './ConfirmModal';
import SuspendContractorModal from './SuspendContractorModal';
import DeactivateContractorModal from './DeactivateContractorModal';
import ConfirmActionModal from './ConfirmActionModal';
import CompanyUsersModal from './CompanyUsersModal';
import ChangeAccountOwnerModal from './ChangeAccountOwnerModal';
import EditCompanyBySuperAdmin from './EditCompanyBySuperAdmin';
import AddFundsToDwollaBalance from './AddFundsToDwollaBalance';
import AddFundingSourceToDwollaBySuperAdmin from './AddFundingSourceToDwollaBySuperAdmin';
import VerifyFundingSource from './VerifyFundingSource';
import DeleteClientFromCompany from './DeleteClientFromCompany';
import NewApiVersion from './NewApiVersion';
import PurchaseCertificate from './PurchaseCertificate';
import CreateOrAddCustomFieldToWorkOrder from './CreateOrAddCustomFieldToWorkOrder';
import TestFailed from './TestFailed';
import AddOrEditTeams from './AddOrEditTeams';
import AddOrEditUsersForManagement from './AddOrEditUsersForManagement';
import AddOrEditCustomFields from './AddOrEditCustomFields';
import ImportRecruitsModal from './ImportRecruitsModal';
import AddOrEditGroups from './AddOrEditGroups';
import CreateOrAddClientApprovalCodeToWorkOrder from './CreateOrAddClientApprovalCodeToWorkOrder';

const Modal = ({ mainContainer } = {}) => (
      <>
        <PortalContainer parentContainer={mainContainer} modalName="purchaseCertificate">
          <PurchaseCertificate mainContainer={mainContainer} />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="newApiVersion">
          <NewApiVersion mainContainer={mainContainer} />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="viewDetailsWorkOrderModal">
          <ViewDetailsWorkOrderModal mainContainer={mainContainer} />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="admminFilters">
          <AdminFilters mainContainer={mainContainer} />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="applyModal">
          <ApplyModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="importWorkOrderModal">
          <ImportWorkOrderModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="viewAllApplicantsForWorkOrderModal">
          <ViewAllApplicantsForWorkOrder />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="unAssignModal">
          <UnAssignModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="contractorDetailsModal">
          <ContractorDetailsModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="nearByContractorModal">
          <NearByContractorModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="copyWorkOrderModal">
          <CopyWorkOrderModal />
        </PortalContainer>
        <CancelWorkOrderExplanationModal />
        <PortalContainer parentContainer={mainContainer} modalName="profile">
          <Profile />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="googleMapsModal" className="portal-element portal-element--google-maps">
          <GoogleMapsModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="imageViewModal">
          <ImageViewModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="blockModal">
          <BlockModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="messageRateModal">
          <MessageRateModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="contractorInviteSelectWorkOrder">
          <ContractorInviteSelectWorkOrder />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="workOrderMessageSystemModal">
          <WorkOrderMessageSystemModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addFunds">
          <AddFunds />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addOrEditPaymentMethod">
          <AddOrEditPaymentMethod />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="importRecruitsModal">
          <ImportRecruitsModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="errorModal">
          <ErrorModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="bulkMessageModal">
          <BulkMessageModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="bulkEditWorkOrders">
          <BulkEditWorkOrders />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="bulkWorkOrderApproveModal">
          <BulkWorkOrderApproveModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="bulkWorkOrderRouteContractorModal">
          <BulkWorkOrderRouteContractorModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="bulkWorkOrderAssignContractorModal">
          <BulkWorkOrderAssignContractorModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="acceptAgreements">
          <AcceptAgreements />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addBankInfoForContractor">
          <AddBankInfoForContractor />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="setUpBankInfoForContractor">
          <SetUpBankInfoForContractor />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="projectAndCompanyControlModal">
          <ProjectAndCompanyControlModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="editCustomFieldModal">
          <EditCustomFieldModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="editClientApprovalCodeModal">
          <EditClientApprovalCodeModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="filtersModal">
          <FiltersModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="contractorTaxInformationModal">
          <ContractorTaxInformationModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="bulkWorkOrderPay">
          <BulkWorkOrderPay />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="confirmModal">
          <ConfirmModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="suspendContractorModal">
          <SuspendContractorModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="deactivateContractorModal">
          <DeactivateContractorModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="confirmActionModal">
          <ConfirmActionModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="companyUsersModal">
          <CompanyUsersModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="changeAccountOwnerModal">
          <ChangeAccountOwnerModal />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="editCompanyBySuperAdmin">
          <EditCompanyBySuperAdmin />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addFundsToDwollaBalance">
          <AddFundsToDwollaBalance />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addFundingSourceToDwollaBySuperAdmin">
          <AddFundingSourceToDwollaBySuperAdmin />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="verifyFundingSource">
          <VerifyFundingSource />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="deleteClientFromCompany">
          <DeleteClientFromCompany />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="createOrAddCustomFieldToWorkOrder">
          <CreateOrAddCustomFieldToWorkOrder />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="createOrAddClientApprovalCodeToWorkOrder">
          <CreateOrAddClientApprovalCodeToWorkOrder />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="testFailed">
          <TestFailed />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addOrEditTeams">
          <AddOrEditTeams mainContainer={mainContainer} />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addOrEditGroups">
          <AddOrEditGroups mainContainer={mainContainer} />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addOrEditUsersForManagement">
          <AddOrEditUsersForManagement mainContainer={mainContainer} />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="addOrEditCustomFields">
          <AddOrEditCustomFields />
        </PortalContainer>
        <PortalContainer parentContainer={mainContainer} modalName="loader">
          <CustomLoader />
        </PortalContainer>
      </>
);

export default Modal;
